/* ═══════════════════════════════════════════════════════════
   SPRINKLES CART SYSTEM v3
   localStorage cart + WhatsApp Order Builder
   Fixes: scrollLock, cart UX, order confirmation, search
   ═══════════════════════════════════════════════════════════ */

(function(){
  'use strict';

  var STORE_KEY = 'sprinkles_cart_v3';
  var WA_NUMBER = document.body.getAttribute('data-wa') || '919097193931';
  var STORE_NAME = document.body.getAttribute('data-store') || 'Sprinkles By Ruchi';

  /* ──────────────────────────────────────
     SCROLL LOCK (fixes the missing functions)
     Preserves scroll position when drawers open
  ────────────────────────────────────── */
  var _scrollY = 0;
  var _locked  = false;

  function scrollLock() {
    if (_locked) return;
    _locked = true;
    _scrollY = window.pageYOffset;
    document.documentElement.style.setProperty('--sp-scroll-top', '-' + _scrollY + 'px');
    document.body.classList.add('sp-locked');
  }
  function scrollUnlock() {
    if (!_locked) return;
    _locked = false;
    document.body.classList.remove('sp-locked');
    document.documentElement.style.removeProperty('--sp-scroll-top');
    window.scrollTo({ top: _scrollY, behavior: 'instant' });
  }

  // Expose globally so sprinkles-app.js can also call them
  window.scrollLock   = scrollLock;
  window.scrollUnlock = scrollUnlock;
  window.spLock       = scrollLock;   // alias used in app.js
  window.spUnlock     = scrollUnlock; // alias used in app.js

  /* ──────────────────────────────────────
     CART STATE
  ────────────────────────────────────── */
  function getCart(){
    try { return JSON.parse(localStorage.getItem(STORE_KEY)) || []; }
    catch(e){ return []; }
  }
  function saveCart(cart){
    localStorage.setItem(STORE_KEY, JSON.stringify(cart));
    updateCartUI();
  }
  function addToCart(item){
    var cart = getCart();
    var found = false;
    for(var i = 0; i < cart.length; i++){
      if(cart[i].name === item.name && cart[i].size === item.size){
        cart[i].qty = Math.min(20, cart[i].qty + item.qty);
        found = true;
        break;
      }
    }
    if(!found){
      cart.push({
        id:       Date.now() + '_' + Math.random().toString(36).substr(2, 5),
        name:     item.name,
        img:      item.img  || '',
        size:     item.size || 'Standard',
        price:    item.price || 0,
        qty:      item.qty  || 1,
        category: item.category || ''
      });
    }
    saveCart(cart);
    showToast('✓ ' + item.name + ' added to cart');
  }
  function removeFromCart(id){
    saveCart(getCart().filter(function(i){ return i.id !== id; }));
  }
  function updateQty(id, delta){
    var cart = getCart();
    for(var i = 0; i < cart.length; i++){
      if(cart[i].id === id){
        cart[i].qty = Math.max(1, Math.min(20, cart[i].qty + delta));
        break;
      }
    }
    saveCart(cart);
  }
  function clearCart(){
    localStorage.removeItem(STORE_KEY);
    updateCartUI();
  }
  function getTotal(){
    return getCart().reduce(function(s, i){ return s + i.price * i.qty; }, 0);
  }
  function getItemCount(){
    return getCart().reduce(function(s, i){ return s + i.qty; }, 0);
  }

  /* ──────────────────────────────────────
     UI UPDATES
  ────────────────────────────────────── */
  function updateCartUI(){
    // Badge count
    var count = getItemCount();
    document.querySelectorAll('.sp-cart-count').forEach(function(b){
      b.textContent = count;
      b.classList.toggle('show', count > 0);
    });
    renderCartDrawer();
  }

  function renderCartDrawer(){
    var body   = document.getElementById('spCartBody');
    var footer = document.getElementById('spCartFooter');
    if(!body) return;

    var cart = getCart();

    if(cart.length === 0){
      body.innerHTML =
        '<div class="sp-cart-empty">' +
          '<div class="sp-cart-empty-icon">🛒</div>' +
          '<p style="font-weight:600;margin-bottom:4px">Your cart is empty</p>' +
          '<p style="font-size:12px;color:#a09080">Browse our menu and add items</p>' +
        '</div>';
      if(footer) footer.style.display = 'none';
      return;
    }

    if(footer) footer.style.display = '';

    var html = '';
    cart.forEach(function(item){
      html +=
        '<div class="sp-cart-item" data-id="' + esc(item.id) + '">' +
          '<div class="sp-cart-item-img">' +
            '<img src="' + esc(item.img) + '" alt="' + esc(item.name) + '" loading="lazy" onerror="this.src=\'https://images.unsplash.com/photo-1578985545062-69928b1d9587?w=120&q=60\'">' +
          '</div>' +
          '<div class="sp-cart-item-info">' +
            '<div class="sp-cart-item-name">' + esc(item.name) + '</div>' +
            '<div class="sp-cart-item-size">' + esc(item.size) + '</div>' +
            '<div class="sp-cart-item-bottom">' +
              '<span class="sp-cart-item-price">₹' + (item.price * item.qty) + '</span>' +
              '<div class="sp-cart-item-qty">' +
                '<button onclick="SpCart.updateQty(\'' + esc(item.id) + '\',-1)" aria-label="Decrease">−</button>' +
                '<span>' + item.qty + '</span>' +
                '<button onclick="SpCart.updateQty(\'' + esc(item.id) + '\',1)" aria-label="Increase">+</button>' +
              '</div>' +
            '</div>' +
          '</div>' +
          '<button class="sp-cart-item-remove" onclick="SpCart.remove(\'' + esc(item.id) + '\')" aria-label="Remove item">✕</button>' +
        '</div>';
    });

    body.innerHTML = html;

    // Update total
    var totalEl = document.getElementById('spCartTotal');
    if(totalEl) totalEl.textContent = '₹' + getTotal();

    // Update header count text (matches id="spCartHeadCount")
    var hdr = document.getElementById('spCartHeadCount') || document.querySelector('.sp-cart-top h3 span');
    if(hdr) hdr.textContent = '(' + getItemCount() + ' item' + (getItemCount() !== 1 ? 's' : '') + ')';
  }

  /* ──────────────────────────────────────
     CART DRAWER OPEN / CLOSE
  ────────────────────────────────────── */
  function openCart(){
    var ov = document.getElementById('spCartOv');
    var dr = document.getElementById('spCartDrawer');
    if(!dr) return;
    if(ov) ov.classList.add('open');
    dr.classList.add('open');
    scrollLock();
    renderCartDrawer();
    populateDateDropdown();
  }

  function populateDateDropdown(){
    var sel = document.getElementById('spCartDate');
    if(!sel || sel.options.length > 1) return;
    var days   = ['Sun','Mon','Tue','Wed','Thu','Fri','Sat'];
    var months = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
    var now = new Date();
    for(var i = 0; i <= 14; i++){
      var d = new Date(now); d.setDate(now.getDate() + i);
      var label = days[d.getDay()] + ', ' + d.getDate() + ' ' + months[d.getMonth()];
      var val   = d.getDate() + ' ' + months[d.getMonth()] + ' ' + d.getFullYear();
      var opt   = document.createElement('option');
      opt.value = val; opt.textContent = label;
      sel.appendChild(opt);
    }
  }
  function closeCart(){
    var ov = document.getElementById('spCartOv');
    var dr = document.getElementById('spCartDrawer');
    if(ov) ov.classList.remove('open');
    if(dr) dr.classList.remove('open');
    scrollUnlock();
  }

  /* ──────────────────────────────────────
     TOAST NOTIFICATION
  ────────────────────────────────────── */
  function showToast(msg){
    var existing = document.querySelector('.sp-cart-toast');
    if(existing) existing.remove();

    var toast = document.createElement('div');
    toast.className = 'sp-cart-toast';
    toast.textContent = msg;
    toast.style.cssText = [
      'position:fixed',
      'bottom:90px',
      'left:50%',
      'transform:translateX(-50%) translateY(8px)',
      'background:#1C1108',
      'color:#fff',
      'padding:10px 22px',
      'border-radius:99px',
      'font-size:13px',
      'font-weight:500',
      'z-index:10000',
      'box-shadow:0 8px 24px rgba(0,0,0,.2)',
      'opacity:0',
      'transition:opacity .25s, transform .25s',
      'pointer-events:none',
      'white-space:nowrap'
    ].join(';');
    document.body.appendChild(toast);

    requestAnimationFrame(function(){
      requestAnimationFrame(function(){
        toast.style.opacity  = '1';
        toast.style.transform = 'translateX(-50%) translateY(0)';
      });
    });

    setTimeout(function(){
      toast.style.opacity   = '0';
      toast.style.transform = 'translateX(-50%) translateY(8px)';
      setTimeout(function(){ toast.remove(); }, 300);
    }, 2200);
  }

  /* ──────────────────────────────────────
     WHATSAPP ORDER BUILDER
  ────────────────────────────────────── */
  function sendWhatsApp(){
    var cart = getCart();
    if(cart.length === 0){
      showToast('⚠️ Your cart is empty');
      return;
    }

    var dateEl  = document.getElementById('spCartDate');
    var msgEl   = document.getElementById('spCartMsg');
    var instrEl = document.getElementById('spCartInstr');

    var dateVal  = dateEl  ? dateEl.value      : '';
    var msgVal   = msgEl   ? msgEl.value.trim() : '';
    var instrVal = instrEl ? instrEl.value.trim(): '';

    var lines = [
      '🎂 *New Order — ' + STORE_NAME + '*',
      '',
      '📋 *Order Details:*',
      '────────────────────'
    ];

    cart.forEach(function(item, idx){
      lines.push((idx + 1) + '. *' + item.name + '*');
      lines.push('   📦 Size: ' + item.size);
      lines.push('   🔢 Qty: ' + item.qty);
      lines.push('   💰 ₹' + item.price + ' × ' + item.qty + ' = ₹' + (item.price * item.qty));
      lines.push('');
    });

    lines.push('────────────────────');
    lines.push('💰 *Total: ₹' + getTotal() + '*');

    if(dateVal){
      var d = new Date(dateVal);
      var dateStr = d.toLocaleDateString('en-IN', {weekday:'short', day:'numeric', month:'short', year:'numeric'});
      lines.push('📅 *Delivery Date:* ' + dateStr);
    }
    if(msgVal){
      lines.push('✍️ *Cake Message:* "' + msgVal + '"');
    }
    if(instrVal){
      lines.push('📝 *Instructions:* ' + instrVal);
    }

    lines.push('');
    lines.push('📍 Please confirm availability & delivery details.');
    lines.push('📍 I\'ll share my delivery address after confirmation.');

    var text = lines.join('\n');
    var url  = 'https://wa.me/' + WA_NUMBER + '?text=' + encodeURIComponent(text);
    window.open(url, '_blank');

    // Show order confirmation modal then clear cart
    setTimeout(function(){
      clearCart();
      closeCart();
      showOrderConfirmModal();
    }, 600);
  }

  /* ──────────────────────────────────────
     ORDER CONFIRMATION MODAL
  ────────────────────────────────────── */
  function showOrderConfirmModal(){
    var existing = document.querySelector('.sp-order-confirm-modal');
    if(existing) existing.remove();

    var overlay = document.createElement('div');
    overlay.className = 'sp-order-confirm-modal';
    overlay.style.cssText = [
      'position:fixed',
      'inset:0',
      'background:rgba(28,17,8,.55)',
      'z-index:10001',
      'display:flex',
      'align-items:center',
      'justify-content:center',
      'padding:16px',
      'backdrop-filter:blur(6px)',
      'animation:spFadeIn .3s ease'
    ].join(';');

    overlay.innerHTML =
      '<div style="' +
        'background:#fff;' +
        'border-radius:20px;' +
        'padding:36px 28px;' +
        'max-width:360px;' +
        'width:100%;' +
        'text-align:center;' +
        'box-shadow:0 24px 64px rgba(0,0,0,.18);' +
        'animation:spSlideUp .35s ease' +
      '">' +
        '<div style="font-size:52px;margin-bottom:16px">✅</div>' +
        '<h3 style="' +
          'font-family:Georgia,serif;' +
          'font-size:22px;' +
          'font-weight:700;' +
          'color:#1C1108;' +
          'margin-bottom:8px' +
        '">Order Sent to WhatsApp!</h3>' +
        '<p style="' +
          'font-size:14px;' +
          'color:#6B5B4E;' +
          'line-height:1.6;' +
          'margin-bottom:6px' +
        '">Your order details have been sent to our WhatsApp.</p>' +
        '<p style="' +
          'font-size:13px;' +
          'color:#9B8B7E;' +
          'line-height:1.6;' +
          'margin-bottom:24px' +
        '">We\'ll confirm your order and delivery time shortly. 🙏</p>' +
        '<div style="display:flex;gap:10px;justify-content:center">' +
          '<button onclick="this.closest(\'.sp-order-confirm-modal\').remove()" style="' +
            'padding:12px 28px;' +
            'background:#C08B3F;' +
            'color:#fff;' +
            'border:none;' +
            'border-radius:99px;' +
            'font-size:14px;' +
            'font-weight:600;' +
            'cursor:pointer;' +
            'font-family:inherit' +
          '">Got it! 🎂</button>' +
          '<a href="https://wa.me/' + WA_NUMBER + '" target="_blank" style="' +
            'padding:12px 20px;' +
            'background:#25D366;' +
            'color:#fff;' +
            'border:none;' +
            'border-radius:99px;' +
            'font-size:14px;' +
            'font-weight:600;' +
            'cursor:pointer;' +
            'font-family:inherit;' +
            'text-decoration:none;' +
            'display:inline-flex;' +
            'align-items:center;' +
            'gap:6px' +
          '">Open WhatsApp</a>' +
        '</div>' +
      '</div>';

    // Close on overlay click
    overlay.addEventListener('click', function(e){
      if(e.target === overlay) overlay.remove();
    });

    document.body.appendChild(overlay);

    // Auto-dismiss after 8 seconds
    setTimeout(function(){
      if(overlay.parentNode) overlay.remove();
    }, 8000);
  }

  /* ──────────────────────────────────────
     PRODUCT CARD INTERACTIONS
     (size select, qty, add-to-cart)
  ────────────────────────────────────── */
  function initProductCards(){
    document.addEventListener('click', function(e){
      var btn;

      // ── Size selector ──
      btn = e.target.closest('.sp-prod-size');
      if(btn && !btn.disabled){
        var siblings = btn.parentElement.querySelectorAll('.sp-prod-size');
        siblings.forEach(function(s){ s.classList.remove('selected'); });
        btn.classList.add('selected');
        // Update price display
        var card = btn.closest('.sp-prod-card');
        if(card){
          var priceEl = card.querySelector('.sp-prod-price');
          var price   = btn.getAttribute('data-price');
          var label   = btn.getAttribute('data-label');
          if(priceEl && price) priceEl.innerHTML = '₹' + price + (label ? ' <small>/ ' + label + '</small>' : '');
          card.setAttribute('data-price', price || '');
        }
        return;
      }

      // ── Qty decrease ──
      btn = e.target.closest('.sp-prod-qty button');
      if(btn){
        var inp = btn.parentElement.querySelector('input');
        if(!inp) return;
        var val = parseInt(inp.value) || 1;
        var txt = btn.textContent.trim();
        inp.value = (txt === '−' || txt === '–' || txt === '-')
          ? Math.max(1, val - 1)
          : Math.min(20, val + 1);
        return;
      }

      // ── Add to Cart ──
      btn = e.target.closest('.sp-add-btn');
      if(btn){
        var card = btn.closest('.sp-prod-card');
        if(!card) return;

        var name     = card.getAttribute('data-name')     || 'Product';
        var img      = card.getAttribute('data-img')      || '';
        var category = card.getAttribute('data-category') || '';
        var sizeBtn  = card.querySelector('.sp-prod-size.selected');
        var size     = sizeBtn ? sizeBtn.getAttribute('data-label') : 'Standard';
        var price    = sizeBtn
          ? parseInt(sizeBtn.getAttribute('data-price')) || 0
          : parseInt(card.getAttribute('data-price'))   || 0;
        var qtyInput = card.querySelector('.sp-prod-qty input');
        var qty      = qtyInput ? parseInt(qtyInput.value) || 1 : 1;

        if(price === 0){
          showToast('⚠️ Please select a size first');
          return;
        }

        addToCart({ name: name, img: img, size: size, price: price, qty: qty, category: category });

        // Visual feedback on button
        var origHtml = btn.innerHTML;
        btn.classList.add('added');
        btn.innerHTML = '<svg viewBox="0 0 24 24"><path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"/></svg> Added!';
        btn.disabled = true;
        setTimeout(function(){
          btn.classList.remove('added');
          btn.innerHTML = origHtml;
          btn.disabled = false;
        }, 1600);

        // Reset qty input
        if(qtyInput) qtyInput.value = 1;
        return;
      }

      // ── Cart icon open ──
      btn = e.target.closest('.sp-cart-btn');
      if(btn){ openCart(); return; }

      // ── Cart overlay / close button ──
      if(e.target.id === 'spCartOv' || e.target.closest('.sp-cart-close')){
        closeCart(); return;
      }

      // ── WhatsApp send button ──
      if(e.target.closest('.sp-cart-wa-btn')){
        sendWhatsApp(); return;
      }
    });
  }

  /* ──────────────────────────────────────
     SHOW MORE / SHOW LESS for category pages
  ────────────────────────────────────── */
  function initShowMore(){
    document.addEventListener('click', function(e){
      var btn = e.target.closest('.sp-show-more-btn, #spShowMore');
      if(!btn) return;
      var wrap = btn.closest('.sp-show-more-wrap');
      var hidden = document.querySelectorAll('.sp-hidden-product');
      if(hidden.length > 0){
        hidden.forEach(function(c){
          c.classList.remove('sp-hidden-product');
          c.classList.add('visible');
        });
        if(wrap) wrap.style.display = 'none';
      }
    });
  }

  /* ──────────────────────────────────────
     PRODUCT SEARCH / FILTER (category pages)
  ────────────────────────────────────── */
  function initSearch(){
    var searchBox = document.getElementById('spProductSearch');
    if(!searchBox) return;

    searchBox.addEventListener('input', function(){
      var q     = searchBox.value.trim().toLowerCase();
      var cards = document.querySelectorAll('.sp-prod-card');
      var count = 0;

      cards.forEach(function(card){
        var name = (card.getAttribute('data-name') || '').toLowerCase();
        var desc = (card.getAttribute('data-desc') || '').toLowerCase();
        var match = !q || name.indexOf(q) !== -1 || desc.indexOf(q) !== -1;
        card.style.display = match ? '' : 'none';
        if(match) count++;
      });

      // Show/hide no-results message
      var noRes = document.getElementById('spNoResults');
      if(noRes) noRes.style.display = count === 0 ? 'block' : 'none';
    });

    // Clear on Escape
    searchBox.addEventListener('keydown', function(e){
      if(e.key === 'Escape'){
        searchBox.value = '';
        searchBox.dispatchEvent(new Event('input'));
      }
    });
  }

  /* ──────────────────────────────────────
     HERO SLIDER (fallback if app.js not loaded)
  ────────────────────────────────────── */
  function initHeroSlider(){
    var slider = document.getElementById('spHeroSlider');
    if(!slider) return;
    var slides = slider.querySelectorAll('.sp-hs-slide');
    if(slides.length < 2) return;
    var cur   = 0;
    var dotsW = document.getElementById('spHeroDots');
    if(dotsW){
      dotsW.innerHTML = '';
      slides.forEach(function(_, i){
        var d = document.createElement('button');
        d.className = 'sp-hs-dot' + (i === 0 ? ' active' : '');
        d.setAttribute('aria-label', 'Slide ' + (i + 1));
        d.addEventListener('click', function(){ goTo(i); });
        dotsW.appendChild(d);
      });
    }
    function goTo(n){
      slides[cur].classList.remove('active');
      if(dotsW && dotsW.children[cur]) dotsW.children[cur].classList.remove('active');
      cur = (n + slides.length) % slides.length;
      slides[cur].classList.add('active');
      if(dotsW && dotsW.children[cur]) dotsW.children[cur].classList.add('active');
    }
    var timer = setInterval(function(){ goTo(cur + 1); }, 4500);
    slider.addEventListener('mouseenter', function(){ clearInterval(timer); });
    slider.addEventListener('mouseleave', function(){ timer = setInterval(function(){ goTo(cur + 1); }, 4500); });
  }

  /* ──────────────────────────────────────
     HEADER SCROLL EFFECT
  ────────────────────────────────────── */
  function initHeader(){
    var hdr = document.getElementById('spHdr') || document.querySelector('.sp-hdr');
    if(!hdr) return;
    window.addEventListener('scroll', function(){
      hdr.classList.toggle('scrolled', window.pageYOffset > 40);
    }, { passive: true });
  }

  /* ──────────────────────────────────────
     MOBILE NAV
  ────────────────────────────────────── */
  function initMobileNav(){
    var burger = document.getElementById('spBurger');
    var nav    = document.getElementById('spMNav');
    var ov     = document.getElementById('spMOv');
    var closeX = document.getElementById('spMX');
    if(!burger || !nav) return;

    function openNav(){
      nav.classList.add('open');
      if(ov) ov.classList.add('open');
      scrollLock();
    }
    function closeNav(){
      nav.classList.remove('open');
      if(ov) ov.classList.remove('open');
      scrollUnlock();
    }
    burger.addEventListener('click', openNav);
    if(closeX) closeX.addEventListener('click', closeNav);
    if(ov) ov.addEventListener('click', closeNav);
    nav.querySelectorAll('a').forEach(function(a){
      a.addEventListener('click', closeNav);
    });
  }

  /* ──────────────────────────────────────
     ANNOUNCEMENT BAR CLOSE
  ────────────────────────────────────── */
  function initAnnouncement(){
    var bar  = document.getElementById('spAnnounce');
    var btn  = bar ? bar.querySelector('.sp-announce-close') : null;
    if(!btn) return;
    btn.addEventListener('click', function(){
      bar.style.height  = bar.offsetHeight + 'px';
      bar.style.overflow = 'hidden';
      requestAnimationFrame(function(){
        bar.style.transition = 'height .3s ease, opacity .3s ease';
        bar.style.height     = '0';
        bar.style.opacity    = '0';
        setTimeout(function(){ bar.style.display = 'none'; }, 350);
      });
      var hdr = document.getElementById('spHdr');
      if(hdr) hdr.classList.remove('has-announce');
    });
  }

  /* ──────────────────────────────────────
     SMOOTH SCROLL — anchor links
  ────────────────────────────────────── */
  function initSmoothScroll(){
    document.querySelectorAll('a[href^="#"]').forEach(function(a){
      a.addEventListener('click', function(e){
        var id = a.getAttribute('href').slice(1);
        var el = id ? document.getElementById(id) : null;
        if(el){ e.preventDefault(); el.scrollIntoView({ behavior: 'smooth', block: 'start' }); }
      });
    });
  }

  /* ──────────────────────────────────────
     BACK TO TOP
  ────────────────────────────────────── */
  function initBackToTop(){
    var btn = document.getElementById('spBackTop');
    if(!btn) return;
    window.addEventListener('scroll', function(){
      btn.classList.toggle('show', window.pageYOffset > 400);
    }, { passive: true });
    btn.addEventListener('click', function(){
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });
  }

  /* ──────────────────────────────────────
     BEST SELLERS CAROUSEL
  ────────────────────────────────────── */
  function initBestSellers(){
    var track = document.getElementById('spBestTrack');
    var btnL  = document.getElementById('spBestLeft');
    var btnR  = document.getElementById('spBestRight');
    if(!track) return;
    var cards = track.querySelectorAll('.sp-prod-card');
    if(!cards.length) return;
    var idx = 0;

    function cardWidth(){
      return cards[0].getBoundingClientRect().width;
    }
    function gap(){
      return parseFloat(getComputedStyle(track).gap) || 14;
    }
    function visCount(){
      return window.innerWidth < 640 ? 1 : window.innerWidth < 1024 ? 2 : 3;
    }
    function clampIdx(n){
      var max = Math.max(0, cards.length - visCount());
      return Math.max(0, Math.min(n, max));
    }
    function move(n){
      idx = clampIdx(n);
      var offset = idx * (cardWidth() + gap());
      track.scrollTo({ left: offset, behavior: 'smooth' });
      // Update button states
      if(btnL) btnL.style.opacity = idx === 0 ? '0.4' : '1';
      if(btnR) btnR.style.opacity = idx >= cards.length - visCount() ? '0.4' : '1';
    }

    // Touch / swipe support
    var touchStartX = 0;
    track.addEventListener('touchstart', function(e){ touchStartX = e.touches[0].clientX; }, {passive:true});
    track.addEventListener('touchend', function(e){
      var dx = touchStartX - e.changedTouches[0].clientX;
      if(Math.abs(dx) > 40){
        if(dx > 0) move(idx + 1);
        else move(idx - 1);
      }
    }, {passive:true});

    if(btnL) btnL.addEventListener('click', function(e){ e.stopPropagation(); move(idx - 1); });
    if(btnR) btnR.addEventListener('click', function(e){ e.stopPropagation(); move(idx + 1); });

    // Sync idx on native scroll
    track.addEventListener('scroll', function(){
      var w = cardWidth() + gap();
      if(w > 0) idx = clampIdx(Math.round(track.scrollLeft / w));
    }, {passive:true});

    var rt;
    window.addEventListener('resize', function(){
      clearTimeout(rt); rt = setTimeout(function(){ idx = 0; track.scrollTo({left:0}); }, 250);
    });
    move(0);
  }

  /* ──────────────────────────────────────
     HELPER — HTML escape
  ────────────────────────────────────── */
  function esc(s){
    if(s === null || s === undefined) return '';
    return String(s)
      .replace(/&/g,  '&amp;')
      .replace(/</g,  '&lt;')
      .replace(/>/g,  '&gt;')
      .replace(/"/g,  '&quot;')
      .replace(/'/g,  '&#39;');
  }

  /* ──────────────────────────────────────
     INIT
  ────────────────────────────────────── */
  function init(){
    initHeader();
    initMobileNav();
    initAnnouncement();
    initProductCards();
    initShowMore();
    initSearch();
    initSmoothScroll();
    initBackToTop();
    initBestSellers();
    // Hero slider: only init from here if app.js hasn't already
    setTimeout(function(){
      if(!window._heroSliderInited) initHeroSlider();
    }, 100);
    updateCartUI();
  }

  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* ──────────────────────────────────────
     GLOBAL API — used by onclick handlers
  ────────────────────────────────────── */
  window.SpCart = {
    open:      openCart,
    close:     closeCart,
    remove:    removeFromCart,
    updateQty: updateQty,
    clear:     clearCart,
    send:      sendWhatsApp,
    addItem:   addToCart
  };

})();
